import {
    SET_REFRESH,
    DASHBOARD_REFRESH,
} from "../../constants/dashboard";

const initialState = {
    refreshing: false,
    summary: {},
    refreshStatus: null
};


export default (state = initialState, action) => {
    switch (action.type) {
        case SET_REFRESH: {
            return {
                ...state,
                refreshing: action.refreshing
            }
        }
        case DASHBOARD_REFRESH: {
            return {
                ...state,
                dashboardRefresh: action.needsRefresh
            }
        }
        default:
            return state
    }
};